import { createStore, applyMiddleware } from 'redux'
import { combineReducers } from 'redux-immutable'
import { fleetinfoReducer } from './reducers/fleetinfoReducer'
import { fleetpageReducer } from './reducers/fleetpageReducer'
import { fleetdriverinfoReducer } from './reducers/fleetdriverinfoReducer'
import {composeWithDevTools } from 'redux-devtools-extension'
import {tenantReducer} from './reducers/tenantreducer'
import {rewardamountReducer} from './reducers/rewardamountReducer'
import {fleetinviteReducer} from './reducers/fleetinviteReducer'
import { fleetactReducer } from './reducers/fleetactReducer'
import {fleetacthistoryReducer} from './reducers/fleetacthistoryReducer'
import {logincityReducer} from './reducers/logincityReducer'
// 引入 thunk
import thunk from 'redux-thunk';

let renders = combineReducers({
    fleetinfoReducer,
    fleetpageReducer,
    fleetdriverinfoReducer,
    tenantReducer,
    rewardamountReducer,
    fleetinviteReducer,
    fleetactReducer,
    fleetacthistoryReducer,
    logincityReducer
})
//applyMiddleware使用中间件
let store = createStore(renders,composeWithDevTools(applyMiddleware(thunk)))

export default store;